import { omit as lodashOmit } from 'lodash';

export type Truthy<T> = T extends false | '' | 0 | null | undefined ? never : T;

export const isTruthy = <T>(value: T): value is Truthy<T> => {
  return Boolean(value);
};

export const omit = <
  T extends Record<string, unknown>,
  F extends readonly string[],
>(
  blob: T,
  f: F
) => {
  return lodashOmit(blob, f) as Omit<T, F[number]>;
};
